import Header from '../../Components/Header/Header';
import Hero from '../../Components/Hero/Hero';
import QuestList from '../../Components/QuestList/QuestList';
import Qualitat from '../../Components/Qualitat/Qualitat';
import Footer from '../../Components/Footer/Footer';
import { useEffect } from 'react';
import s from './Homepage.module.css';
import { Link } from 'react-scroll';

export default function HomePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Header />
      <Hero />
      <div className={s.descContainer}>
        <h1>Квести в Одесі — хоррор квест-кімнати Outlast Quest</h1>
        <div className={s.description}>
          <p>
            Outlast Quest — це найкращі хорор-квести в Одесі! Ми створили для
            вас страшні квест-кімнати, які стануть справжнім випробуванням вашої
            сміливості. Наша мережа квест-кімнат в Одесі пропонує унікальні
            ігрові сценарії, які перевірять вашу витримку, логіку та здатність
            діяти в екстремальних ситуаціях. Зануртеся в атмосферу страху,
            напруги та незабутніх емоцій, розгадуючи загадки й долаючи
            перешкоди, які ми підготували для вас.
          </p>
          <p>
            Відчуйте справжню напругу у квест-кімнаті «Прокляття монахині», де
            кожен звук і тінь нагадують про давнє зло, що приховується поруч.
            Випробуйте свою стійкість у «Цирку жахів», де ви станете учасниками
            моторошного шоу, з якого не так просто знайти вихід. Пориньте у світ
            небезпеки та несподіваних подій у «Поворот не туди», де кожне
            рішення може змінити хід гри. Зіткніться з межею між життям і смертю
            у квесті «Клінічна смерть», де страх, містика та напруга
            переплітаються в одну моторошну історію. А у грі «Остання гра» вам
            доведеться пройти через найскладніші випробування, де кожен крок
            наближає до розгадки головної таємниці.
          </p>
          <p>
            Outlast Quest — це не просто квести, це справжній виклик для вашої
            команди. Тут важливі не лише сміливість і рішучість, а й уміння
            працювати разом, швидко мислити та знаходити вихід навіть у
            найнапруженіших ситуаціях. Кожна гра створена для того, щоб
            перенести вас у новий світ, де адреналін, страх і задоволення від
            перемоги поєднуються у незабутній досвід.
          </p>
          <p>
            Забронюйте свою гру в Outlast Quest онлайн — і пориньте у світ
            страху, загадок та пригод. Хорор-квести в Одесі ще ніколи не були
            такими захопливими! Оберіть свій сценарій, зберіть команду та
            розпочніть подорож, де кожна хвилина тримає вас на межі можливого.
          </p>
        </div>
        <div className={s.strongCont}>
          <p className={s.reservDesc}>
            <strong>
              Приєднуйтесь до нас і переживіть незабутні моменти страху і
              захоплення!
            </strong>
          </p>
          <Link to="questi" smooth={true} duration={400}>
            <button className={s.descLink}>Забронювати зараз</button>
          </Link>
        </div>
      </div>
      <Qualitat />
      <QuestList />
      <Footer />
    </div>
  );
}
